// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* flexDirection: 'column', alignItems: 'center' */

.modalTransfer {
  flex-direction: column;
  align-items: center;
}

.width50Percent {
  width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/Modal.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* flexDirection: 'column', alignItems: 'center' */\n\n.modalTransfer {\n  flex-direction: column;\n  align-items: center;\n}\n\n.width50Percent {\n  width: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
